import produce from 'immer';
import { makeRandomId } from '../../utils/helper';
import * as ActionTypes from '../action-types';

const initialState = {
  total: JSON.parse(localStorage.getItem('localCart') || '[]')
    .map(item => (item.giftCard ? 1 : item.quantity))
    .reduce((acc, curr) => acc + curr, 0),

  localCart: JSON.parse(localStorage.getItem('localCart') || '[]')
};

const LocalCart = (state = initialState, action) => {
  let newState = {};
  switch (action.type) {
    case ActionTypes.DELETE_LOCAL_CART_ITEM:
      newState = {
        ...state,
        localCart: state.localCart.filter(item => {
          if (item.giftCard) {
            return item.id !== action.productId;
          } else {
            return parseInt(item.product_id) !== parseInt(action.productId);
          }
        })
      };
      localStorage.setItem('localCart', JSON.stringify(newState.localCart));
      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      return newState;

    case ActionTypes.ADD_EXTEND_TO_PRODUCT:
      newState = { ...state };
      const foundProductAddExtend = newState.localCart.findIndex(
        product => product.id == action.product.id
      );

      // if product exists just update quantities
      if (foundProductAddExtend != -1) {
        const nextState = produce(newState, ns => {
          ns.localCart[foundProductAddExtend].extend_plan = action.extendPlan;
          ns.localCart[foundProductAddExtend].extend_plan_id =
            action.extendPlan?.planId;
        });

        newState = { ...nextState };
      }

      localStorage.setItem('localCart', JSON.stringify(newState.localCart));
      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      return newState;

    case ActionTypes.REMOVE_EXTEND_FROM_PRODUCT:
      newState = { ...state };
      const foundProductRemoveExtend = newState.localCart.findIndex(
        product => product.id == action.product.id
      );

      // if product exists just update quantities
      if (foundProductRemoveExtend != -1) {
        const nextState = produce(newState, ns => {
          ns.localCart[foundProductRemoveExtend].extend_plan = null;
          ns.localCart[foundProductRemoveExtend].extend_plan_id = null;
        });

        newState = { ...nextState };
      }

      localStorage.setItem('localCart', JSON.stringify(newState.localCart));
      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      return newState;

    case ActionTypes.ADD_SWATCH_LOCAL_CART_ITEM:
      newState = { ...state };
      newState.localCart = [
        ...newState.localCart,
        {
          quantity: 1,
          product_id: action.swatch.id,
          id: action.swatch.id,
          type: 'increase',
          swatch: true,
          is_swatch: true,
          shippingService: null,
          product: {
            name: action.swatch.name,
            price: action.swatch.price,
            id: action.swatch.id,
            is_swatch: true
          }
        }
      ];
      localStorage.setItem('localCart', JSON.stringify(newState.localCart));
      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      return newState;

    case ActionTypes.ADD_GIFT_CARD_LOCAL_CART_ITEM:
      newState = { ...state };

      newState.localCart = [
        ...newState.localCart,
        {
          id: `${makeRandomId(5)}`,
          product: null,
          giftCard: {
            id: action.designId,
            gift_card_design_id: action.giftCard.designId,
            original_balance: action.giftCard.originalBalance,
            recipient_email: action.giftCard.recipientEmail,
            recipient_name: action.giftCard.recipientName,
            personalized_message: action.giftCard.personalizedMessage,
            delivery_time: action.giftCard.deliveryTime,
            from: action.giftCard.from,
            giftCardDesign: action.giftCard.giftCardDesign
          }
        }
      ];

      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);

      localStorage.setItem('localCart', JSON.stringify(newState.localCart));

      return newState;

    case ActionTypes.UPDATE_GIFT_CARD_LOCAL_CART_ITEM:
      newState = { ...state };
      const findIndex = newState.localCart.findIndex(
        x =>
          x.id.toLowerCase() == action.cartProduct.cartProductId.toLowerCase()
      );
      if (findIndex == -1) return newState;

      const nState = produce(newState, draftState => {
        draftState.localCart[findIndex] = {
          id: action.cartProduct.cartProductId,
          product: null,
          giftCard: {
            id: action.cartProduct.designId,
            gift_card_design_id: action.cartProduct.designId,
            original_balance: action.cartProduct.originalBalance,
            recipient_email: action.cartProduct.recipientEmail,
            recipient_name: action.cartProduct.recipientName,
            personalized_message: action.cartProduct.personalizedMessage,
            delivery_time: action.cartProduct.deliveryTime,
            from: action.cartProduct.from,
            giftCardDesign: action.cartProduct.giftCardDesign
          }
        };
      });

      localStorage.setItem('localCart', JSON.stringify(nState.localCart));
      return nState;

    case ActionTypes.ADD_PRODUCT_LOCAL_CART_ITEM:
      newState = { ...state };
      const productAlreadyAddedIdx = newState.localCart.findIndex(
        product => product.id == action.product.id
      );

      // if product exists just update quantities
      if (productAlreadyAddedIdx != -1) {
        const nextState = produce(newState, ns => {
          ns.localCart[productAlreadyAddedIdx].quantity += action.quantity;
          ns.localCart[productAlreadyAddedIdx].extend_plan = action.extendPlan;
          ns.localCart[productAlreadyAddedIdx].extend_plan_id =
            action.extendPlan?.planId;
        });

        newState = { ...nextState };
      } else {
        newState.localCart = [
          ...newState.localCart,
          {
            quantity: action.quantity,
            extend_plan: action.extendPlan,
            extend_plan_id: action.extendPlan?.planId,
            product_id: action.product.id,
            id: action.product.id,
            sku: action.product.sku,
            type: 'increase',
            swatch: false,
            is_swatch: false,
            source: action.source,
            shippingService: null,
            product: {
              is_swatch: false,
              id: action.product.id,
              name: action.product.name,
              sku: action.product.sku,
              slug: action.product.slug,
              price: action.product.price,
              images: action.product.images,
              ...(action.product.leg && {
                leg: {
                  id: action.product.leg.id,
                  name: action.product.leg.name
                }
              }),
              ...(action.product.fabric && {
                fabric: {
                  name: action.product.fabric ? action.product.fabric.name : '',
                  image: action.product.fabric
                    ? action.product.fabric.image
                    : '',
                  ...(action.product.fabric.collaborator && {
                    collaborator: {
                      id: action.product.fabric.collaborator.id,
                      name: action.product.fabric.collaborator.name
                    }
                  })
                }
              }),
              ...(action.product.frame && {
                frame: {
                  id: action.product.frame,
                  name: action.product.name,
                  ...(action.product.frame.subcategories && {
                    subcategories: action.product.frame.subcategories
                  }),
                  orientation: action.product?.frame.orientation,
                  size: action.product?.frame?.size
                    ? {
                        id: action.product?.frame?.size?.id,
                        name: action.product?.frame?.size?.name
                      }
                    : null
                }
              })
            }
          }
        ];
      }
      localStorage.setItem('localCart', JSON.stringify(newState.localCart));
      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      return newState;

    case ActionTypes.INCREASE_PRODUCT_LOCAL_CART_ITEM:
      newState = { ...state };

      const nextState = produce(newState, draftState => {
        const Idx = draftState.localCart.findIndex(cartItem => {
          return cartItem.product_id === action.productId;
        });

        draftState.localCart[Idx].quantity =
          draftState.localCart[Idx].quantity + 1;

        draftState.total = draftState.localCart
          .map(item => item.quantity)
          .reduce((acc, curr) => acc + curr, 0);
      });

      localStorage.setItem('localCart', JSON.stringify(nextState.localCart));
      return nextState;

    case ActionTypes.DECREASE_PRODUCT_LOCAL_CART_ITEM:
      newState = { ...state };
      const getIdx = newState.localCart.findIndex(cartItem => {
        return cartItem.product_id === action.productId;
      });

      newState = {
        ...newState,
        localCart: [
          ...newState.localCart.slice(0, getIdx),
          {
            ...newState.localCart[getIdx],
            quantity: newState.localCart[getIdx].quantity - 1
          },
          ...newState.localCart.slice(getIdx + 1)
        ]
      };

      newState.total = newState.localCart
        .map(item => (item.giftCard ? 1 : item.quantity))
        .reduce((acc, curr) => acc + curr, 0);
      localStorage.setItem('localCart', JSON.stringify(newState.localCart));

      return newState;

    case ActionTypes.UPDATE_PRODUCT_QUANTITY: {
      newState = { ...state };

      const nextState = produce(newState, draftState => {
        const index = newState.localCart.findIndex(cartItem => {
          return cartItem.product_id == action.productId;
        });

        if (index >= 0) {
          draftState.localCart[index].quantity = action.quantity;
        }

        draftState.total = draftState.localCart
          .map(item => item.quantity)
          .reduce((acc, curr) => acc + curr, 0);
      });

      localStorage.setItem('localCart', JSON.stringify(nextState.localCart));
      return nextState;
    }

    case ActionTypes.RESET_LOCAL_CART_ITEM: {
      localStorage.removeItem('localCart');
      const resetState = {
        total: 0,
        localCart: []
      };
      return resetState;
    }
    case ActionTypes.ADD_SHIPPING_SERVICE_ID: {
      const nextState = produce(state, newState => {
        const idx = newState.localCart.findIndex(
          p => p.product_id === action.productId
        );
        newState.localCart[idx].shippingServicePrice =
          action.shippingServicePrice;
        //will remove in the future
        newState.localCart[idx].shipping_service_id = action.shippingServiceId;

        newState.localCart[idx].shippingService = {
          id: action.shippingServiceId,
          price: action.shippingServicePrice
        };
      });

      localStorage.setItem('localCart', JSON.stringify(nextState.localCart));
      return nextState;
    }
    case ActionTypes.REMOVE_SHIPPING_SERVICE_ID: {
      const nextState = produce(state, newState => {
        const idx = newState.localCart.findIndex(
          p => p.product_id === action.productId
        );
        newState.localCart[idx].shipping_service_id = '';
        newState.localCart[idx].shippingService = null;
      });

      localStorage.setItem('localCart', JSON.stringify(nextState.localCart));
      return nextState;
    }
    default:
      return state;
  }
};

export default LocalCart;
